import { call, put, select } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import moment from 'moment';
import { push } from 'redux-little-router';
import { SEARCH_PAYMENT_FORM } from '../constants';
import { submitRSPDataFailure, submitRSPSuccess } from '../redux/actions';
import { createPdf } from '../services/api';

export function* submitQSASaga({ payload: { step } }) {
  const formData = yield select(getFormValues(SEARCH_PAYMENT_FORM));
  const parseDate = (date) => (moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : null);

  const { isOk, data, error } = yield call(createPdf, {
    uin: formData.get('uin'),
    sum: formData.get('sum'),
    dateFrom: formData.get('dateRange') && parseDate(formData.get('dateRange')[0]),
    dateTo: formData.get('dateRange') && parseDate(formData.get('dateRange')[1]),
    paymentOrder: formData.get('paymentOrder'),
    kbk: formData.get('kbk'),
    oktmo: formData.get('oktmo'),
  });
  if (isOk && data) {
    yield put(submitRSPSuccess(data));
    yield put(push({ query: { step } }, { persistQuery: true }));
  } else {
    yield put(submitRSPDataFailure(error));
  }
}
